module.exports = __webpack_public_path__ + "img/National Day Logo.ae222e4.png";